export const FEATURE_TOGGLES = {
  BATCH_INBOX: "batch_inbox",
  POSTHOG_ETAB_ONBOARDING: "posthog_etab_event_onboarding",
  POSTHOG_ETAB_TEMPLATE_FUNNEL: "posthog_etab_event_template_funnel",
  POSTHOG_CANDIDATE_NOTIFICATION_CENTER: "posthog_candidate_event_notification_center",
  DISPLAY_PERMANENT_SUBSCRIPTION_PAGE: "display_permanent_subscription_page",
};
